module.exports = __webpack_public_path__ + "img/chivas_crystalgold_age-removebg-preview.5cc8b132.png";